import {ReactNode} from 'react';
import IntlMessages from 'src/domain/utility/IntlMessages';

type AppEmptyProps = {
  compact?: boolean;
  message?: ReactNode;
};

// Touch #3: the Ahlan bag, faded, with a short message. The full version for
// tables and lists; a compact one (a smaller bag, the message alone) for
// dropdowns. `message` replaces the default "No data yet".
export const AppEmpty = ({compact, message}: AppEmptyProps) => (
  <div className={compact ? 'touch-empty touch-empty-compact' : 'touch-empty'}>
    <span className='touch-empty-icon'>
      <img src='/assets/images/ahlan-bag.svg' alt='' />
    </span>
    <div className='touch-empty-title'>
      {message ?? <IntlMessages id='touch.empty.title' />}
    </div>
    {!compact && (
      <div className='touch-empty-hint'>
        <IntlMessages id='touch.empty.hint' />
      </div>
    )}
  </div>
);

// The app-wide empty state (AntD ConfigProvider renderEmpty): tables and
// lists get the full version, every dropdown the compact one.
const renderAppEmpty = (componentName?: string) => (
  <AppEmpty compact={componentName !== 'Table' && componentName !== 'List'} />
);

export default renderAppEmpty;
